import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { Box } from '@nerdwallet/currency';
import { stringSelectSpec } from '../../lib/editing-configs';

import './image-content-row.less';

const ImageContentRow = ({
  id,
  className,
  children,
  centeredInParent,
  columns,
  justifyContent,
}) => (
  <Box
    id={id}
    style={{ justifyContent }}
    className={classNames([className], {
      [`image-content-row__cont-${columns}-col`]: columns,
      'centered-in-parent': centeredInParent,
    })}
  >
    {children}
  </Box>
);

ImageContentRow.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
  centeredInParent: PropTypes.bool,
  columns: PropTypes.string,
  justifyContent: PropTypes.string,
};

ImageContentRow.displayName = 'ImageContentRow';

ImageContentRow.defaultProps = {
  id: null,
  className: null,
  children: null,
  centeredInParent: false,
  columns: null,
};

ImageContentRow.getEditingConfig = (componentDocument) => {
  const imageContentRowConfigInputs = [
    stringSelectSpec(
      'columns',
      'Number of columns',
      [
        {
          value: '1',
          label: '1',
        },
        {
          value: '2',
          label: '2',
        },
        {
          value: '3',
          label: '3',
        },
      ],
      {
        help: 'Number of columns in layout on tablet and desktop (mobile will always default to 1 column)',
      }
    ),
  ];
  if (_.get(componentDocument, 'props.columns', '1') > 1) {
    imageContentRowConfigInputs.push(
      stringSelectSpec(
        'justifyContent',
        'Items layout alignment',
        [
          {
            value: 'space-between',
            label: 'Space between',
          },
          {
            value: 'space-around',
            label: 'Space around',
          },
          {
            value: 'space-evenly',
            label: 'Space evenly',
          },
          {
            value: 'start',
            label: 'Start',
          },
          {
            value: 'end',
            label: 'End',
          },
          {
            value: 'center',
            label: 'Center',
          },
        ],
        {
          help: 'Item alignments when there is more than one column (default is "space-between")',
        }
      )
    );
  }
  return imageContentRowConfigInputs;
};

export default ImageContentRow;
